module.exports = __webpack_public_path__ + "static/media/31.4c35f110.jpg";